import clientStorage from "./client-storage";
import analyticsHelper from "../helpers/analytics.helper";
import {webviewFullscreenAdPreload, webviewFullscreenAdShow} from "@vicman-wi/webview-api/functions/ads/fullscreen";
import {WebviewEventSubscriber} from "@vicman-wi/webview-api/tools/WebviewEventSubscriber";

const cacheKey = "native_ads_hits:fullscreen";

window.webviewEvents.fullscreenAdShown.on(new WebviewEventSubscriber(adShown));
window.webviewEvents.fullscreenAdClosed.on(new WebviewEventSubscriber(adClosed));

export function showNativeAds() {
  const placeAdHits = clientStorage.getInteger(cacheKey, 0);

  const shouldShowAdsOnAndroid = window.appConfig.nativeAds.isEnabled
    && !window.clientConfig.isPro
  ;

  const shouldShowAdsOnIOS = window.appConfig.nativeAds.isEnabled
    && !window.clientConfig.isPro
  ;

  const shouldShowAds = window.clientConfig.isWebviewIos
    ? shouldShowAdsOnIOS
    : shouldShowAdsOnAndroid;

  if (shouldShowAds) {
    if (window.clientConfig.isWebview) {
      analyticsHelper.nativeAdsShowRequest();
      webviewFullscreenAdShow("");
    } else {
      console.log("start fullscreen ads");
    }
  }

  clientStorage.setInteger(cacheKey, placeAdHits + 1);
}

export function resetNativeAdsCounter() {
  clientStorage.setInteger(cacheKey, 0);
}

function adShown(isShown) {
  if (isShown) {
    analyticsHelper.nativeAdsShown();
  }
}

function adClosed() {
  preloadNativeAds();
}

export function preloadNativeAds() {
  const shouldPreloadAds = window.clientConfig.isWebview
    && window.appConfig.nativeAds.isEnabled
    && !window.clientConfig.isPro;

  if (shouldPreloadAds) {
    analyticsHelper.nativeAdsPreload();
    webviewFullscreenAdPreload().catch(console.error);
  }
}